import { render, staticRenderFns } from "./SendComment.vue?vue&type=template&id=c8f4526a&scoped=true&"
import script from "./SendComment.vue?vue&type=script&lang=js&"
export * from "./SendComment.vue?vue&type=script&lang=js&"
import style0 from "./SendComment.vue?vue&type=style&index=0&id=c8f4526a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f4526a",
  null
  
)

export default component.exports